export default __webpack_public_path__ + "static/media/350.ec63592d.png";